module.exports = __webpack_public_path__ + "static/media/pathwayHouseLogo.c0115994.png";